"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonList = void 0;
const react_1 = __importDefault(require("react"));
const SkeletonListItem_1 = require("../ListItem/SkeletonListItem");
const utils_1 = require("../../Utils/utils");
const clsx_1 = __importDefault(require("clsx"));
const SkeletonList = ({ itemCount = 8, className, ariaLabel }) => (react_1.default.createElement("ul", { className: (0, clsx_1.default)(`flex flex-col px-7 my-4 focus-visible:outline-0`, className), "aria-label": `${ariaLabel || 'Skeleton loader list'}` }, [...Array(itemCount)].map((_item) => {
    return react_1.default.createElement(SkeletonListItem_1.SkeletonListItem, { key: (0, utils_1.uuid)() });
})));
exports.SkeletonList = SkeletonList;
